// **That it is still working shows** (3.4, D6, CA8): no exact bar, just no
// blank minute between uploading a file and what it proposes. Not framed or
// boxed, on purpose: it goes with what is above, it is not something else.
//
// Painted by the panel and by the full Brain screen, which both take files.

import { useTranslation } from 'react-i18next'
import { Loader2 } from 'lucide-react'

export function ReadingFile({ name }: { name: string }) {
  const { t } = useTranslation()
  if (!name) return null
  return (
    <div className="flex items-center gap-2 text-sm text-muted-foreground" aria-live="polite">
      <Loader2 className="h-4 w-4 shrink-0 animate-spin" />
      <span>{t('brain.archivo.trabajando', { nombre: name })}</span>
    </div>
  )
}
